import React from 'react';
import '../../css/AboutUs.css';

function AboutUs() {
    return (
        <div className="about-us">
            <p>
                Welcome to <strong>prettylovecolombo.com</strong>, your trusted destination for <strong>premium sex toys in Sri Lanka</strong>. We’re more than just an adult shop—we’re a discreet, judgment-free space dedicated to helping you explore your desires safely, privately, and confidently.
            </p>

            <h2>💜 Who We Are</h2>
            <p>
                Founded with the mission to break taboos and promote healthy conversations around pleasure, <strong>Pretty Love Colombo</strong> is a 100% Sri Lankan-owned online store. We understand the needs and values of our local community, and we’re here to serve adults across the island—from Colombo to Jaffna, Galle to Kandy.
            </p>
            <p>
                Our curated selection of products is handpicked for quality, safety, and satisfaction. From <strong>vibrators, dildos, and couple toys</strong>, to <strong>bondage gear and lubricants</strong>, we offer everything you need to elevate your intimate life.
            </p>

            <h2>🚚 Discreet & Fast Delivery Across Sri Lanka</h2>
            <p>
                We believe your privacy is sacred. That’s why we offer <strong>discreet packaging and fast delivery</strong> anywhere in Sri Lanka. No one will know what’s inside—not even the delivery agent.
            </p>
            <p>
                Our packaging is plain, our billing is confidential, and your details are always kept secure.
            </p>

            <h2>✅ Why Choose prettylovecolombo.com?</h2>
            <ul>
                <li>🌟 <strong>Wide Range of Adult Toys in Sri Lanka</strong></li>
                <li>🔒 <strong>100% Discreet & Confidential Service</strong></li>
                <li>📍 Locally based with fast islandwide shipping</li>
                <li>💬 Friendly, non-judgmental customer support</li>
                <li>🎁 Regular offers, bundle deals & new arrivals</li>
            </ul>
            <p>
                Whether you’re new to sex toys or an experienced explorer, we’re here to guide you with <strong>educational blogs, product guides</strong>, and a growing online community.
            </p>

            <h2>🛍️ Your Pleasure. Your Way.</h2>
            <p>
                We believe that sexual wellness is a part of overall wellness. At <strong>Pretty Love Colombo</strong>, we celebrate love, intimacy, and exploration. Our mission is to empower adults in Sri Lanka to embrace their desires safely and confidently.
            </p>
        </div>
    );
}

export default AboutUs;
